import React from 'react';
import PropTypes from 'prop-types';
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.log(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="w-100 h-100vh d-flex justify-content-center align-items-center">
          <div className="px-2">
            <h3 className="text-center mb-2">Oops!</h3>
            <h4 className="error">
              There&apos;s an error
            </h4>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
export default ErrorBoundary;

ErrorBoundary.propTypes = {
  children: PropTypes.element.isRequired,
  history: PropTypes.object
};
